import { FacebookIcon, InstagramIcon } from './icons'

interface SocialLinksProps {
  className: string
  linkClassName: string
}

const SOCIAL_LINKS = [
  {
    href: 'https://www.facebook.com/profile.php?id=61592136380197',
    label: 'Roofora auf Facebook',
    Icon: FacebookIcon,
  },
  {
    href: 'https://www.instagram.com/roof.ora/',
    label: 'Roofora auf Instagram',
    Icon: InstagramIcon,
  },
] as const

/** Shared external social-profile links for all public and authenticated Roofora shells. */
export function SocialLinks({ className, linkClassName }: SocialLinksProps) {
  return (
    <div className={className}>
      {SOCIAL_LINKS.map(({ href, label, Icon }) => (
        <a
          key={href}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClassName}
          aria-label={label}
        >
          <Icon />
        </a>
      ))}
    </div>
  )
}
